// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/0f4b233e/" + chunkId + "." + __webpack_require__.h() + ".v0f4b233e.js";
};